import React, { useState, useEffect } from 'react'
import Classes from './styles/style.module.css'
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { usePreventScrolling } from '../../../../../../../Hooks/usePreventScrolling';
import { CloseIcon } from '../../../../../../../utils/Icons';

export default function ReschedulePopup({ closePopup, submitPopup }) {
    const handleBgClick = () => {
        closePopup();
    }

    const handleCardClick = (event) => {
        event.stopPropagation();
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        submitPopup();
    }

    usePreventScrolling();

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className={Classes.popup}
                onClick={handleBgClick}
            >
                <motion.div
                    initial={{ y: 7 }}
                    animate={{ y: 0 }}
                    exit={{ y: 7 }}
                    transition={{ duration: 0.25 }}
                    className={Classes.card}
                    onClick={(event) => { handleCardClick(event) }}
                >
                    <div className={Classes.close} onClick={closePopup} >
                        <CloseIcon height='20px' fill='white' />
                    </div>
                    <div className={Classes.bgPopup} >
                        <div></div>
                        <h5 className={Classes.title} > Reschedule </h5>
                        <div className={Classes.curveCon} >

                        </div>
                    </div>
                    <form onSubmit={handleSubmit} >
                        <div className={Classes.cardCon} >
                            <div className={Classes.flexColGroup}>
                                <div className={Classes.flexCol1}>
                                    <h5 className={Classes.label} >New Appointment Date</h5>
                                    <input
                                        type="date"
                                        className={Classes.inputField}
                                        required
                                    />
                                </div>
                            </div>

                            <div className={Classes.flexColGroup}>
                                <div className={Classes.flexCol1}>
                                    <div className='flexAlign10' >
                                        <h5 className={Classes.label} >Message to Client</h5>
                                        <div className={Classes.optionalText} >
                                            <h5>Optional</h5>
                                        </div>
                                    </div>
                                    <div className={Classes.textAreaCon}>
                                        <textarea
                                            rows={4}
                                            name="notes"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={Classes.flexAlign} >
                                <button type="button" onClick={closePopup} className={Classes.btn1}>
                                    <h5> Back </h5>
                                </button>
                                <button type="button" onClick={handleSubmit} className={Classes.btn2}>
                                    <h5> Confirm </h5>
                                </button>
                            </div>
                        </div>
                    </form>
                </motion.div>
            </motion.div>
        </>
    )
}
